import { render } from "./Adress.vue?vue&type=template&id=5a94c6a0"
import script from "./Adress.vue?vue&type=script&lang=js"
export * from "./Adress.vue?vue&type=script&lang=js"

import "./Adress.vue?vue&type=style&index=0&id=5a94c6a0&lang=less"
script.render = render

export default script